// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__14IpY","selects":"Documents_selects__1qjA7"};